export function transformNumToString(num: number) {
  return num.toString().replace('.', ',');
}
